var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomWidgetAlt = function SvgCustomWidgetAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.116 11.884-.53.53.53-.53c-.13-.13-.237-.328-.3-.79-.064-.482-.066-1.13-.066-2.094V8c0-.964.002-1.612.067-2.095.062-.461.169-.659.3-.789.13-.13.327-.237.788-.3C4.388 4.753 5.036 4.75 6 4.75h12c.964 0 1.612.002 2.095.067.461.062.659.169.789.3.13.13.237.327.3.788.064.483.066 1.131.066 2.095v1c0 .964-.002 1.612-.067 2.095-.062.461-.169.659-.3.789-.13.13-.327.237-.788.3-.483.064-1.131.066-2.095.066H6c-.964 0-1.612-.002-2.095-.066-.461-.063-.659-.17-.789-.3ZM13.5 19.25h-3c-.5 0-.641-.004-.744-.024a1.25 1.25 0 0 1-.98-.976h6.449a1.25 1.25 0 0 1-.981.976c-.103.02-.243.024-.744.024Zm3-3.5h-9c-.5 0-.641-.004-.744-.024a1.25 1.25 0 0 1-.98-.976h12.449a1.25 1.25 0 0 1-.981.976c-.103.02-.243.024-.744.024Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

export default SvgCustomWidgetAlt;